import apiClient from "../../utils/apiClient.js";
import { RESET_PASSWORD, SIGN_IN_USER, SIGN_UP_USER } from "../../ApiEndpoints";

export const signInUser = (payload) => apiClient.post(SIGN_IN_USER, payload);

export const signUpUser = (payload) => apiClient.post(SIGN_UP_USER, payload);

export const resetPassword = (payload) => apiClient.post(RESET_PASSWORD, payload);
